import React from 'react';
import { Switch, Route, RouteComponentProps } from 'react-router-dom';
import ListaMonografiasPage from './ListaMonografiasPage';
import MonografiaPage from './MonografiaPage';
import AgendamentoBancaPage from './AgendamentoBancaPage';
import ResumoConvite from './ResumoConvite';
import ChatPage from '../Professor/ChatPage';
import PreProjetoPage from '../Professor/PreProjetoPage';

const ProfessorPage: React.FC<RouteComponentProps<string>> = (
  props: RouteComponentProps<string>
) => (
  <Switch>
    <Route
      path={`${props.match.path}/monografia/:id`}
      component={MonografiaPage}
    />
    <Route
      path={`${props.match.path}/agendamento/:id`}
      component={AgendamentoBancaPage}
    />
    <Route 
      path={`${props.match.path}/convite/:id`}
      component={ResumoConvite} 
    />
    <Route 
      path={`${props.match.path}/orientacoes/:id`}
      component={ChatPage} 
    />
    <Route 
      path={`${props.match.path}/preprojeto/:id`}
      component={PreProjetoPage} 
    />
    <Route path={props.match.path} component={ListaMonografiasPage} />
  </Switch>
);

export default ProfessorPage;
